import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12 text-center mb-5 mt-5" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-4 mb-3" }, "Área do Cliente")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mt-4 mb-3" }, "Login automático")
], -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12 mb-3" }
const _hoisted_11 = {
  key: 0,
  class: "mt-3 text-primary text-center"
}
const _hoisted_12 = {
  key: 1,
  class: "mt-3 text-danger text-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)

import { onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";

//services
import * as service from "@/services/clienteService";
import storeControle from "@/utils/storeControle";
import { getToken } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginExterno',
  setup(__props) {


//vue
const router = useRouter();
const route = useRoute();

var controle = reactive({
  clienteId: 0 as number | null,
  senha: "",
  model: {} as service.ClienteLogin,
  status: "" as string,
  erro: "" as string
})

onMounted(() => {

  console.log("Query Params:", route.query);
  controle.clienteId = route.query["clienteId"] ? Number(route.query["clienteId"]) : null
  controle.senha = route.query["senha"] ? String(route.query["senha"]) : ""

  if (controle.clienteId && controle.senha) {
    controle.model.cpf = String(controle.clienteId);
    controle.model.senha = String(controle.senha);
    login();
  }

});

function login() {

  // Lógica de login aqui
  console.log("Realizando login para o clienteId:", controle.clienteId);
  controle.status = "Realizando login...";
  console.log("Login:", controle.model);

  var param = { clienteId: controle.clienteId, senha: controle.senha } as service.ClienteLoginExterno
  service.loginExterno(param)
    .then((response) => {

       if (response.accessToken) {
          localStorage.setItem('user', JSON.stringify(response));
          storeControle.token = getToken();
          storeControle.usuario = response;
          controle.status = "Login realizado com sucesso! Redirecionando...";
          controle.erro = "";
        }

        setTimeout(() => {
          router.push({ name: "PainelCliente" });
        }, 3000);
    })
    .catch((error) => {
      controle.status = "";
      controle.erro = error.message || error;
    });
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _unref(imgLogin),
            alt: "Login do Cliente",
            class: "img-fluid"
          }, null, 8, _hoisted_6)
        ]),
        _hoisted_7,
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_unref(controle).erro == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(controle).status), 1))
            : _createCommentVNode("", true),
          (_unref(controle).erro != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(controle).erro), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_13
    ])
  ]))
}
}

})